<template>
    <v-row class="row-cols-lg-5">
        <v-col cols="4" sm="3" v-for="brand in brands" :key="brand._id" class="list-item">
            <router-link :to="`/gshop/brand/giftcards?_category=${_category || ''}&_brand=${brand?._id}`"> 
                <v-img :src="`https://daehanbooksgiftcard.com/${brand.thumb}`" class="border w-100" alt="shinsegae" contain :aspect-ratio="1 / 1"/>
            </router-link>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        brands: { type: Array, default: [] },
    },
    data() {
        return {};
    },
    computed: {
        _category() {
            return this.$route.query._category;
        }
    }
};
</script>

<style lang="scss" scoped>
.row{
    margin: -5px;
    >[class*="col"]{
        padding: 5px;
    }
}
// .list-item {
//     cursor: pointer;
// }
</style>
